




































import { Component, Vue } from 'vue-property-decorator';
import { PasswordReset } from '@/models';

@Component({})
export default class PasswordResetPage extends Vue {
  form: PasswordReset = new PasswordReset();

  submit(): void {
    (this.$refs.form as any).validate();
    if (this.form.valid) {
      const form = this.form;

      this.$store.dispatch('account/passwordReset', { form }).then(() => {
        (this.$refs.form as any).reset();
      });
    }
  }
}
